import React, { useEffect, useRef } from 'react';
import ChatMessage from './ChatMessage';

const ChatMessages = ({
  messages,
  isModerator,
  onModAction,
  occupantRoles,
}) => {
  const containerRef = useRef(null);
  const shouldAutoScroll = useRef(true);

  const handleScroll = () => {
    if (!containerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    shouldAutoScroll.current = scrollHeight - scrollTop - clientHeight < 60;
  };

  useEffect(() => {
    if (shouldAutoScroll.current && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div
      className="live-chat-messages"
      ref={containerRef}
      onScroll={handleScroll}
      aria-live="polite"
      aria-relevant="additions"
      role="log"
    >
      {messages.map((msg) => (
        <ChatMessage
          key={msg.id}
          message={msg}
          isModerator={isModerator}
          onModAction={onModAction}
          occupantRoles={occupantRoles}
        />
      ))}
    </div>
  );
};

export default ChatMessages;
